

// // export default ContactForm;

// import React, { useState } from "react";
// import "./ContactForm.css";
// import { CgMail } from "react-icons/cg";
// import { BsSend } from "react-icons/bs";
// import { BiLogoGmail } from "react-icons/bi";
// import { AiFillTwitterCircle, AiFillLinkedin, AiFillFacebook } from "react-icons/ai";
// import toast from "react-hot-toast";
// import ErpNavbar from "../ErpNavbar";
// import { CircularProgress } from "@mui/material";

// const ContactForm = () => {
//     const [formdata, setFormData] = useState({
//         name: "",
//         email: "",
//         phone: "",
//         schoolName: "",
//         message: "",
//     });
//     const [loading, setLoading] = useState(false);

//     const changeHandler = (event) => {
//         setFormData((prevData) => ({
//             ...prevData,
//             [event.target.name]: event.target.value,
//         }));
//     };

//     const submitHandler = async (event) => {
//         event.preventDefault();
//         setLoading(true);

//         try {
//             const response = await fetch("https://api.isnartecherp.online/api/v1/createContact", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(formdata),
//             });

//             if (!response.ok) {
//                 throw new Error("Failed to send message");
//             }

//             const responseData = await response.json();
//             console.log(responseData); // Handle response data as needed

//             toast.success("Message sent successfully!");
//             setFormData({
//                 name: "",
//                 email: "",
//                 phone: "",
//                 schoolName: "",
//                 message: "",
//             });
//         } catch (error) {
//             console.error("Error sending message:", error);
//             toast.error("Failed to send message. Please try again later.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="w-full h-full ">
            
//             <div className="text-white">
//                 <div className="contact relative">
//                     <div className="relative top-[5rem]">
//                         <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-center bg-gradient-to-r from-cyan-500 to-emerald-400 text-transparent bg-clip-text">
//                             Get In Touch
//                         </h2>
//                         <h3 className="text-[20px] font-inter text-center font-medium bg-gradient-to-r from-cyan-500 to-emerald-400 text-transparent bg-clip-text">
//                             We solve your queries as soon as possible..
//                         </h3>
//                     </div>
//                 </div>

//                 <div className="contact-responsive flex flex-col md:flex-row w-full md:w-[70%] mx-auto justify-around bg-gradient-to-r from-blue-900 to-teal-900 relative -top-[125px]">
//                     {/* Form Section */}
//                     <div className="flex flex-col w-full gap-20 md:w-2/3">
//                         <div className="flex mt-[30px] justify-between items-center">
//                             <h2 className="text-[25px] font-semibold font-inter ml-8">
//                                 Send us a Message
//                             </h2>
//                             <CgMail className="text-[30px] mr-7" />
//                         </div>

//                         <form onSubmit={submitHandler}>
//                             <div className="input-container">
//                                 <div className="input-wrapper">
//                                     <input
//                                         type="text"
//                                         autoComplete="off"
//                                         required
//                                         name="name"
//                                         value={formdata.name}
//                                         onChange={changeHandler}
//                                         className="input-data"
//                                         id="name"
//                                     />
//                                     <div className="underline-text relative"></div>
//                                     <label htmlFor="name">Your Name</label>
//                                 </div>

//                                 <div className="input-wrapper">
//                                     <input
//                                         type="text"
//                                         required
//                                         autoComplete="off"
//                                         name="email"
//                                         value={formdata.email}
//                                         onChange={changeHandler}
//                                         className="input-data"
//                                         id="email"
//                                     />
//                                     <div className="underline-text"></div>
//                                     <label htmlFor="email">Email Address</label>
//                                 </div>
//                             </div>

//                             <div className="input-container">
//                                 <div className="input-wrapper">
//                                     <input
//                                         type="tel"
//                                         required
//                                         autoComplete="off"
//                                         name="phone"
//                                         value={formdata.phone}
//                                         onChange={changeHandler}
//                                         id="phone"
//                                         className="input-data"
//                                     />
//                                     <div className="underline-text"></div>
//                                     <label htmlFor="phone">Phone Number</label>
//                                 </div>

//                                 <div className="input-wrapper">
//                                     <input
//                                         type="text"
//                                         required
//                                         autoComplete="off"
//                                         name="schoolName"
//                                         value={formdata.schoolName}
//                                         onChange={changeHandler}
//                                         id="schoolName"
//                                         className="input-data"
//                                     />
//                                     <div className="underline-text"></div>
//                                     <label htmlFor="schoolName">School Name</label>
//                                 </div>
//                             </div>

//                             <div className="input-container">
//                                 <div className="input-wrapper">
//                                     <input
//                                         type="text"
//                                         autoComplete="off"
//                                         required
//                                         name="message"
//                                         value={formdata.message}
//                                         onChange={changeHandler}
//                                         className="input-data"
//                                         id="message"
//                                     />
//                                     <div className="underline-text"></div>
//                                     <label htmlFor="message">Message</label>
//                                 </div>
//                             </div>

//                             <div className="btn">
//                                 <button type="submit" disabled={loading}>
//                                     {loading ? <CircularProgress /> : "Submit"}
//                                 </button>
//                                 <span>
//                                     {loading ? '' : <BsSend />}
//                                 </span>
//                             </div>
//                         </form>
//                     </div>

//                     {/* Information Section (Hidden on Small Screens) */}
//                     <div className="information w-[23rem] bg-[#4158d0] hidden md:block">
//                         <h2 className="contact-text">Contact information</h2>

//                         <div className="gmail-info">
//                             <div className="gmail-logo">
//                                 <BiLogoGmail className="text-[35px]" />
//                             </div>
//                             <div className="mt-4 gmail">enquiries@isnartech.com</div>
//                         </div>

//                         <div className="flex gap-4 mb-4">
//                             <span className="text-[25px] border rounded-md">
//                                 <AiFillLinkedin />
//                             </span>
//                             <span className="text-[25px] border rounded-md">
//                                 <AiFillTwitterCircle />
//                             </span>
//                             <span className="text-[25px] border rounded-md">
//                                 <AiFillFacebook />
//                             </span>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* <HomeFooter /> */}
//         </div>
//     );
// };

// export default ContactForm;

import React, { useState } from "react";
import { CgMail } from "react-icons/cg";
import { BsSend } from "react-icons/bs";
import { BiLogoGmail, BiPhone, BiMap } from "react-icons/bi";
import { AiFillTwitterCircle, AiFillLinkedin, AiFillFacebook } from "react-icons/ai";
import toast from "react-hot-toast";

const displayFont = { fontFamily: "'Fraunces', serif" };
const bodyFont = { fontFamily: "'Sora', sans-serif" };

// Same robust focus treatment used across the registration flow: no native
// browser outline, a soft custom glow instead, smooth transition.
const fieldClass =
  "w-full px-4 py-2.5 bg-white border border-[#E3E8F0] rounded-xl text-[#101826] placeholder-[#A6AFBD] text-sm shadow-[0_1px_2px_rgba(16,24,38,0.04)] outline-none transition-[box-shadow,border-color] duration-200 ease-out focus:border-[#2E63B8] focus:shadow-[0_0_0_4px_rgba(46,99,184,0.15)]";
const fieldStyle = { outline: "none" };
const labelClass = "block text-[13px] mb-1.5 text-[#5A6478] font-medium";

const ContactForm = () => {
  const [formdata, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    schoolName: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const changeHandler = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value,
    }));
  };

  const submitHandler = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/v1/createContact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formdata),
      });

      if (!response.ok) {
        throw new Error("Failed to send message");
      }

      await response.json();

      toast.success("Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        schoolName: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen w-full px-4 py-12 md:py-16 bg-gradient-to-b from-[#EEF3FC] via-white to-[#F8FAFD]"
      style={bodyFont}
    >
      {/* Header */}
      <div className="text-center max-w-2xl mx-auto mb-10">
        <h1 style={displayFont} className="text-3xl md:text-4xl text-[#101826]">
          Get in touch
        </h1>
        <p className="text-[#5A6478] text-lg mt-3">
          We solve your queries as soon as possible.
        </p>
      </div>

      {/* Card */}
      <div className="max-w-5xl mx-auto bg-white border border-[#EDF1F7] rounded-3xl shadow-[0_30px_70px_-35px_rgba(22,56,99,0.4)] overflow-hidden">
        {/* Brand accent bar */}
        <div className="h-[4px] w-full bg-gradient-to-r from-[#E8A63C] via-[#2E63B8] to-[#163863]" />

        <div className="grid md:grid-cols-[1fr_320px]">
          {/* Form */}
          <div className="p-6 md:p-10">
            <div className="flex items-center justify-between mb-8">
              <h2 style={displayFont} className="text-xl md:text-2xl text-[#101826]">
                Send us a message
              </h2>
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#163863] to-[#2E63B8] flex items-center justify-center shadow-md shadow-[#163863]/25">
                <CgMail className="text-white text-xl" />
              </div>
            </div>

            <form onSubmit={submitHandler} className="space-y-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label className={labelClass} htmlFor="name">
                    Your Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    required
                    name="name"
                    value={formdata.name}
                    onChange={changeHandler}
                    className={fieldClass}
                    style={fieldStyle}
                    id="name"
                    placeholder="Enter your full name"
                  />
                </div>

                <div>
                  <label className={labelClass} htmlFor="email">
                    Email Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    required
                    autoComplete="off"
                    name="email"
                    value={formdata.email}
                    onChange={changeHandler}
                    className={fieldClass}
                    style={fieldStyle}
                    id="email"
                    placeholder="you@example.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label className={labelClass} htmlFor="phone">
                    Phone Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    required
                    autoComplete="off"
                    name="phone"
                    value={formdata.phone}
                    onChange={changeHandler}
                    id="phone"
                    className={fieldClass}
                    style={fieldStyle}
                    placeholder="10-digit phone number"
                  />
                </div>

                <div>
                  <label className={labelClass} htmlFor="schoolName">
                    School Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    autoComplete="off"
                    name="schoolName"
                    value={formdata.schoolName}
                    onChange={changeHandler}
                    id="schoolName"
                    className={fieldClass}
                    style={fieldStyle}
                    placeholder="Enter your school name"
                  />
                </div>
              </div>

              <div>
                <label className={labelClass} htmlFor="message">
                  Message <span className="text-red-500">*</span>
                </label>
                <textarea
                  autoComplete="off"
                  required
                  rows={4}
                  name="message"
                  value={formdata.message}
                  onChange={changeHandler}
                  className={fieldClass}
                  style={fieldStyle}
                  id="message"
                  placeholder="How can we help?"
                />
              </div>

              <div className="pt-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-gradient-to-r from-[#163863] to-[#2E63B8] text-white text-[15px] font-semibold shadow-lg shadow-[#163863]/25 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:hover:translate-y-0"
                >
                  {loading ? (
                    <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                    </svg>
                  ) : (
                    <>
                      Submit <BsSend className="text-base" />
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>

          {/* Contact information panel */}
          <div className="bg-gradient-to-br from-[#163863] to-[#0E2748] p-8 flex flex-col justify-between text-white">
            <div>
              <h3 style={displayFont} className="text-xl mb-6">
                Contact information
              </h3>

              <div className="space-y-5 text-sm">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                    <BiLogoGmail className="text-lg" />
                  </div>
                  <a href="mailto:enquiries@isnartech.com" className="pt-1.5 hover:text-[#E8A63C] transition-colors break-all">
                    enquiries@isnartech.com
                  </a>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                    <BiPhone className="text-lg" />
                  </div>
                  <div className="pt-1.5 text-[#C9D3E3]">
                    <p>+91-9891940289</p>
                    <p>+91-7704836280</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                    <BiMap className="text-lg" />
                  </div>
                  <p className="pt-1.5 text-[#C9D3E3]">
                    Tower D, Sector-102, Gurgaon, India
                  </p>
                </div>
              </div>
            </div>

            <div className="flex gap-3 mt-10">
              <a
                href="#"
                aria-label="LinkedIn"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#E8A63C] hover:text-[#163863] transition-colors"
              >
                <AiFillLinkedin className="text-lg" />
              </a>
              <a
                href="#"
                aria-label="Twitter"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#E8A63C] hover:text-[#163863] transition-colors"
              >
                <AiFillTwitterCircle className="text-lg" />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#E8A63C] hover:text-[#163863] transition-colors"
              >
                <AiFillFacebook className="text-lg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
